import { SAMPLE_CUSTOMER_SEND_GROUP_LIST, SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST } from "../common/SampleData";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

import { yellow } from "@mui/material/colors";


// 取引先送信グループ削除ダイアログ
export default function DeleteCustomerSendGroupDialog({open, onCloseDialog, customerSendGroupData}) {

  const onClickDelete = (event) => {
    deleteCustomerSendGroup(customerSendGroupData);
    onCloseDialog(event, true);
  }

  const onClickCancel = (event) => {
    onCloseDialog(event, false);
  }

  const deleteCustomerSendGroup = (customerSendGroupData) => {
    SAMPLE_CUSTOMER_SEND_GROUP_MEMBER_SHOP_LIST
      .filter((data) => data.customer_send_group_id === customerSendGroupData.customer_send_group_id)
      .forEach((data) => data.delete_flag = true)
    
    SAMPLE_CUSTOMER_SEND_GROUP_LIST
      .filter((data) => data.customer_send_group_id === customerSendGroupData.customer_send_group_id)
      .forEach((data) =>  data.delete_flag = true)

    alert(`取引先送信グループを削除しました。\n取引先送信グループ名: ${customerSendGroupData.name}`);
  }

  return(
    <Dialog open={open} onClose={onClickCancel}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>取引先送信グループ削除</Typography>
        <Box marginTop={2} marginBottom={1}>
          <Typography>以下の取引先送信グループを削除します。</Typography>
          <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
            <Typography fontSize={20}>取引先送信グループ:&nbsp;{customerSendGroupData.name}</Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs textAlign='center'>
            <Button
              variant="contained"
              color='error'
              onClick={onClickDelete}
            >
              削除
            </Button>
          </Grid>
          <Grid item xs textAlign='center'>
            <Button variant="outlined" onClick={onClickCancel}>戻る</Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  )
}